/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement, useState } from 'react';
import { Field, useFormikContext, getIn } from 'formik';
import { INVALID_NUMERIC_FORMAT } from '@services/ErrorMessages';
import { tile, iNominationInfoDisplay } from '@interfaces/interfaces';
import { iNominationFormValues } from '@services/NominationService';
import { ABNACNField, AddressFieldAccessible, Alert, ContactInputWithExperian, EmailFieldWithExperian, TextInput, TileRadioAccessible } from '@components';
// eslint-disable-next-line import/no-duplicates
import gridFormStyles from '@pages/forms/Grid.module.scss';
// eslint-disable-next-line import/no-duplicates
import gridStyles from '@pages/forms/Grid.module.scss';
import InfoIcon from '../../../images/info.svg';

import styles from './CompanyFormNominate.module.scss';

interface iCompanyFormNominate {
  displayObject: iNominationInfoDisplay;
  currentStepNo: string;
}

const CompanyFormNominate = ({ displayObject, currentStepNo }: iCompanyFormNominate): ReactElement => {
  const { values, touched }: { values: iNominationFormValues; touched: any } = useFormikContext();
  const formikContext = useFormikContext();
  const companyFields = displayObject.pages.companyContactInformation[currentStepNo].fields;
  const isStep11 = currentStepNo === 'step11';
  const [isDisabled, setDisabled] = useState(false);
  const { IndividualPostalAddress, IndividualResidentialAddress } = values;
  const PostalAddress = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NotPostalAddress = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );
  // const WarningMessage = (): ReactElement => (
  //   <>
  //     <p>You have already given us the name of the person who was driving. Now we need details for the person named on the fine.</p>
  //   </>
  // );
  const TILE_DATA: tile[] = [
    {
      body: <PostalAddress />,
      value: 'true',
    },
    {
      body: <NotPostalAddress />,
      value: 'false',
    },
  ];
  const Abn = (): ReactElement => (
    <>
      <div>ABN</div>
    </>
  );

  const Acn = (): ReactElement => (
    <>
      <div>ACN</div>
    </>
  );

  const ABNACN_TILE_DATA: tile[] = [
    {
      body: <Acn />,
      value: 'ACN',
    },
    {
      body: <Abn />,
      value: 'ABN',
    },
  ];
  const DifferentToStreetAddress: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={gridFormStyles.form}>
        {isStep11
          && (
            <div className={gridFormStyles.gridColFull}>
              <Field component={TextInput} name={companyFields.givenName.formikName} title={companyFields.givenName.title} isMandatory />
              <Field component={TextInput} name={companyFields.familyName.formikName} title={companyFields.familyName.title} isMandatory />
              {/* {isStep11 && values.GivenNamesYourDetailsCompany && values.FamilyNameYourDetailsCompany && (values.GivenNamesSomeoneElse || values.GivenNamesSoldDisposed) === values.GivenNamesYourDetailsCompany && (values.FamilyNameSomeoneElse || values.FamilyNameSoldDisposed) === values.FamilyNameYourDetailsCompany && (
                <div className={gridStyles.gridColFull}>
                  <Alert
                    icon={InfoIcon}
                    message={<WarningMessage />}
                    theme="info2"
                    classAlt={styles.boxheight}
                    color="green"
                  />
                </div>
              )} */}
              <Field component={TextInput} name={companyFields.positionInCompany.formikName} title={companyFields.positionInCompany.title} isMandatory />
              <Field component={ContactInputWithExperian} name={companyFields.organisationContactNumber.formikName} title="Contact phone number" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={displayObject.mode} secondaryContact={false} hasPrimaryNumberType={false} warningMessage={companyFields.organisationContactNumberWarning.formikName} />
              <Field component={EmailFieldWithExperian} name={companyFields.emailAddress.formikName} title="Email" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={displayObject.mode} noEmailField={companyFields.emailAddressYesNo.formikName} currentSP={companyFields.emailAddressYesNo.title} warningMessage={companyFields.emailAddressWarning.formikName} />
            </div>
          )}
        {/* <h2>Company Details</h2> */}
        <br />
        <div className="vfH3">Company Details</div>
        <Field name={companyFields.companyName.formikName} component={TextInput} title={companyFields.companyName.title} isMandatory />
        <Field
          component={TileRadioAccessible}
          name={companyFields.abnacnType.formikName}
          title={companyFields.abnacnType.title}
          tileData={ABNACN_TILE_DATA}
          orientationRow
          isMandatory
          tileChanged={() => {
            formikContext.setFieldValue(companyFields.abnNo.formikName, '');
            formikContext.setFieldTouched(companyFields.abnNo.formikName, false);
            formikContext.setFieldError(companyFields.abnNo.formikName, INVALID_NUMERIC_FORMAT);
            formikContext.setFieldValue(companyFields.acnNo.formikName, '');
            formikContext.setFieldTouched(companyFields.acnNo.formikName, false);
            formikContext.setFieldError(companyFields.acnNo.formikName, INVALID_NUMERIC_FORMAT);
          }}
        />
        {getIn(values, companyFields.abnacnType.formikName) === 'ABN'
        && (
        <Field
          component={ABNACNField}
          name={companyFields.abnNo.formikName}
          title={companyFields.abnNo.title}
          isMandatory
          ABNACNType={getIn(values, companyFields.abnacnType.formikName)}
          ABNACNValidFieldName={companyFields.isABNValid.formikName}
        />
        )}
        {getIn(values, companyFields.abnacnType.formikName) === 'ACN'
        && (
        <Field
          component={ABNACNField}
          name={companyFields.acnNo.formikName}
          title={companyFields.acnNo.title}
          isMandatory
          ABNACNType={getIn(values, companyFields.abnacnType.formikName)}
          ABNACNValidFieldName={companyFields.isACNValid.formikName}
        />
      )}
        <AddressFieldAccessible
          name={companyFields.companyStreetAddress.formikName}
          title={companyFields.companyStreetAddress.title}
          manualAddressText="Enter address manually"
          isMandatory
        />
        {!isStep11
          && (
            <>
              <Field component={ContactInputWithExperian} name={companyFields.organisationContactNumber.formikName} title="Contact phone number" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={displayObject.mode} secondaryContact={false} hasPrimaryNumberType={false} noContactFieldRequired noContactFieldName={companyFields.noContactNumber.formikName} currentSP={companyFields.noContactNumber.title} warningMessage={companyFields.organisationContactNumberWarning.formikName} />
              <Field component={EmailFieldWithExperian} name={companyFields.emailAddress.formikName} title="Email" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={displayObject.mode} noEmailField={companyFields.emailAddressYesNo.formikName} currentSP={companyFields.emailAddressYesNo.title} warningMessage={companyFields.emailAddressWarning.formikName} />
            </>
          )}
        {isStep11 && (
          <div className={gridFormStyles.gridColFull}>
            <Field
              component={TileRadioAccessible}
              name={companyFields.differentToStreetAddress.formikName}
              title={companyFields.differentToStreetAddress.title}
              tileData={DifferentToStreetAddress}
              tileContainer
              isMandatory
              orientationRow
              classname={styles.tile}
            />
            {getIn(values, companyFields.differentToStreetAddress.formikName) === 'true'
              && (
                <div className={gridFormStyles.gridColFull}>
                  <AddressFieldAccessible
                    name={companyFields.companyPostalAddress.formikName}
                    title={companyFields.companyPostalAddress.title}
                    manualAddressText="Enter address manually"
                    isMandatory
                    disabled={isDisabled}
                  />
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyFormNominate;
